import ConfirmManualDeposit from '@/components/ModalRenderer/components/FI/ConfirmManualDeposit';
import WithdrawalSuccess from '@/components/ModalRenderer/components/FI/WithdrawalSuccess';

const FI = {
  CONFIRM_MANUAL_DEPOSIT: ConfirmManualDeposit,
  WITHDRAWAL_SUCCESS: WithdrawalSuccess,
} as const;

export default FI;
